module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst headOptions = model.headOptions || {}\nconst cssClasses = {\nhead: ['head'],\nbutton: [],\n}\nif(config.bootstrapVersion){\ncssClasses.head.push('accordion-header')\ncssClasses.button.push('accordion-button')\n}\n%><h2 class=\"<%- cssClasses.head.join(' ') %>\">\n<button class=\"<%- cssClasses.button.join(' ') %>\" type=\"button\">\n<% if(headOptions.icon){ %>\n<i class=\"<%- headOptions.icon %> tab-icon\"></i>\n<% } else if(config.static && config.static.icon){ %>\n<i class=\"<%- config.static.icon %> tab-icon\"></i>\n<% } %>\n<div class=\"title\"><%= headOptions.title || config.static.title %></div>\n<%\nif((headOptions.buttons || []).length > 0){\n%><%- include('../form/elements/buttons', { formMapping: { buttons: headOptions.buttons }}) %><%\n}\n%>\n</button>\n</h2>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\accordion\\head.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const headOptions = model.headOptions || {}
const cssClasses = {
head: ['head'],
button: [],
}
if(config.bootstrapVersion){
cssClasses.head.push('accordion-header')
cssClasses.button.push('accordion-button')
}

    ; __line = 11
    ; __append("<h2 class=\"")
    ; __append( cssClasses.head.join(' ') )
    ; __append("\">\n<button class=\"")
    ; __line = 12
    ; __append( cssClasses.button.join(' ') )
    ; __append("\" type=\"button\">\n")
    ; __line = 13
    ;  if(headOptions.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 14
    ; __append( headOptions.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 15
    ;  } else if(config.static && config.static.icon){ 
    ; __append("\n<i class=\"")
    ; __line = 16
    ; __append( config.static.icon )
    ; __append(" tab-icon\"></i>\n")
    ; __line = 17
    ;  } 
    ; __append("\n<div class=\"title\">")
    ; __line = 18
    ; __append(escapeFn( headOptions.title || config.static.title ))
    ; __append("</div>\n")
    ; __line = 19
    ; 
if((headOptions.buttons || []).length > 0){

    ; __line = 21
    ; __append( include('../form/elements/buttons', { formMapping: { buttons: headOptions.buttons }}) )
    ; 
}

    ; __line = 23
    ; __append("\n</button>\n</h2>")
    ; __line = 25
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\accordion\head.ejs

}